import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from '../ui/CtaButton';
import { images } from '../../data/images';
const ease = [0.23, 1, 0.32, 1] as const;
const item = {
  hidden: {
    opacity: 0,
    y: 16
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.28,
      ease
    }
  }
};
export function Hero() {
  return <section id="top" className="relative flex min-h-[100svh] w-full items-end overflow-hidden bg-ink" data-id="element-149" data-mp="hvqpk2k9k32o">
      <div className="absolute inset-y-0 right-0 w-full lg:w-[52%]" data-id="element-150" data-mp="mtiubx60bjoa">
        <img src={images.hero} alt="Hombre de espaldas flexionando el brazo en un gimnasio oscuro" className="h-full w-full object-cover object-[45%_40%]" data-id="element-151" data-mp="quubdeatewkv" />
        <div className="absolute inset-0 bg-ink/70 lg:bg-ink/10" aria-hidden="true" data-id="element-152" data-mp="10lyoe8gxk7d2" />
        <div className="absolute inset-y-0 left-0 hidden w-1 bg-brand lg:block" aria-hidden="true" data-id="element-153" data-mp="15ks66d392kj1" />
      </div>

      <motion.div className="relative mx-auto w-full max-w-7xl px-5 pb-16 pt-32 sm:px-8 md:pb-24" initial="hidden" animate="show" variants={{
      show: {
        transition: {
          staggerChildren: 0.06
        }
      }
    }} data-id="element-154" data-mp="1aj3bcailo6ux">
        <div className="max-w-4xl lg:max-w-[44vw] lg:pr-10" data-id="element-155" data-mp="4n4zklpnwqah">
          <motion.p variants={item} className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.2em] text-white sm:text-sm" data-id="element-156" data-mp="3vuhhx42a79rz">
            <span className="h-0.5 w-8 bg-brand" aria-hidden="true" data-id="element-157" data-mp="sean7n1ugmvc" />
            Fitness en Español para Latinos en USA
          </motion.p>

          <motion.h1 variants={item} className="mt-6 font-display text-5xl font-black uppercase leading-[0.9] tracking-tight text-white sm:text-7xl lg:text-[4.75rem] xl:text-[5.5rem]" data-id="element-158" data-mp="ngimq4n4vsfj">
            Descubre <span className="text-brand" data-id="element-159" data-mp="ekt6sb4gfq9j">qué está frenando</span> tu pérdida de grasa y tu progreso en el
            gimnasio.
          </motion.h1>

          <motion.p variants={item} className="mt-7 max-w-2xl text-lg leading-relaxed text-muted md:text-xl" data-id="element-160" data-mp="16dtktlx14fte">
            Agenda un diagnóstico fitness gratuito y recibe claridad sobre qué necesitas ajustar en tu entrenamiento,
            alimentación y hábitos para empezar a perder grasa, ganar músculo y dejar de improvisar.
          </motion.p>

          <motion.div variants={item} className="mt-10 flex flex-col items-start gap-4" data-id="element-161" data-mp="2qu1h33co4sul">
            <CtaButton className="w-full sm:w-auto" data-id="element-162" data-mp="2vte35lvptvw4" />
            <p className="text-sm text-muted" data-id="element-163" data-mp="2huwffo5t8je7">Gratis. Sin compromiso. Solo claridad sobre tu próximo paso.</p>
          </motion.div>
        </div>
      </motion.div>
    </section>;
}